// Dashboard Events evolution page translations (en-US), loaded into dashboard.events.evolution by ../en-US.events.js
module.exports = {
  menu: "Evolution",
  title: "Events Evolution",
  description: "Events created, active and interactions by {gran}.",
  panels: {
    newEvents: "New events by {gran}",
    active: "Active events (average) by {gran}",
    windows: "New events — this period vs. previous ones",
    windowsNote: "Each bar has the same length as the selected period.",
    weekday: "Clicks by day of the week (average)",
    interactions: "Interactions by {gran}",
  },
  hints: {
    shorterThan7: "n/a — period shorter than 7 days",
  },
  series: {
    promoted: "Promoted",
    clicks: "Clicks",
    shared: "Shared",
  },
  weekdays: {
    mon: "Monday",
    tue: "Tuesday",
    wed: "Wednesday",
    thu: "Thursday",
    fri: "Friday",
    sat: "Saturday",
    sun: "Sunday",
  },
  weekdaysShort: {
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    sun: "Sun",
  },
  panelInfo: {
    newEvents: "Events created in each interval.\nSource: Firebase (event counters).",
    active: "Average active events running per day in each interval.\nSource: Firebase (events).",
    windows: "Events created in this period and in the previous ones of the same length.\nSource: Firebase (event counters).",
    weekday: "Average clicks on event links on each weekday in the period.\nSource: Firebase (event counters).",
    interactions: "Events promoted, shared and link clicks in each interval.\nSource: Firebase (event counters).",
  },
};
